export interface RoleData {
  id: number;
  name: string;
  description: string;
  isActive: boolean;
}

export const initialRoleData: RoleData = {
  id: 0,
  name: "",
  description: "",
  isActive: false,
};

export interface RoleActionData {
  id: number;
  moduleId: number;
  moduleName: string;
  actionId: number;
  actionName: string;
}

export const initialRoleActionData: RoleActionData = {
  id: 0,
  moduleId: 0,
  moduleName: "",
  actionId: 0,
  actionName: "",
};
